import {
  Choice, Slider, Counter, SECTION_EMOJI, YES_NO_NSP, YES_NO_NSP_BIN,
  buildCommonStartSteps, buildTabacSteps, buildAlcoolSteps, buildMentalSteps, buildRedFlagsStep,
  updateExtra, getExtra,
} from './BilanWidgets';

// Tranche 70-75 ans : focus autonomie (ADL/IADL) + chutes + dépistages tardifs
export function build7075Steps(config, answers, update) {
  const setEx = (k, v) => updateExtra(answers, update, k, v);
  const gx = (k) => getExtra(answers, k);

  const adlItems = [
    { key: 'adl_laver', label: 'Je me lave seul(e)' },
    { key: 'adl_habiller', label: 'Je m\'habille seul(e)' },
    { key: 'adl_toilettes', label: 'Je vais aux toilettes seul(e)' },
    { key: 'adl_deplacer', label: 'Je me déplace dans mon domicile seul(e)' },
    { key: 'adl_continence', label: 'Je contrôle mes envies (urine / selles)' },
    { key: 'adl_nourrir', label: 'Je mange seul(e)' },
  ];
  const iadlCommon = [
    { key: 'iadl_telephone', label: 'J\'utilise le téléphone seul(e)' },
    { key: 'iadl_courses', label: 'Je fais mes courses seul(e)' },
    { key: 'iadl_transport', label: 'J\'utilise les transports seul(e)' },
    { key: 'iadl_medicaments', label: 'Je gère mes médicaments seul(e)' },
    { key: 'iadl_argent', label: 'Je gère mon argent seul(e)' },
  ];
  const iadlFemme = [
    { key: 'iadl_repas', label: 'Je prépare mes repas seule' },
    { key: 'iadl_menage', label: 'Je fais le ménage seule' },
    { key: 'iadl_lessive', label: 'Je fais la lessive seule' },
  ];

  return [
    ...buildCommonStartSteps(config, answers, update),
    ...buildTabacSteps(answers, update),
    ...buildAlcoolSteps(answers, update),
    // Alimentation simplifiée
    { id: 'ali_eau', emoji: '💧', title: 'Verres d\'eau par jour ?', subtitle: "L'hydratation est essentielle à cet âge",
      render: () => <Slider testid="q-ali-eau" value={gx('ali_eau')} onChange={(v) => setEx('ali_eau', v)} min={0} max={15} step={1} unit=" verres"
        presets={[{ value: 2, label: '<3' }, { value: 4, label: '3-4' }, { value: 6, label: '5-6' }, { value: 8, label: '7-8' }, { value: 10, label: '9+' }]} />
    },
    { id: 'ali_sel', emoji: '🧂', title: 'Consommation de sel au quotidien ?',
      render: (a, u, advance) => <Choice testid="q-ali-sel" value={gx('ali_sel')} onChange={(v) => { setEx('ali_sel', v); advance(); }}
        options={[{value:'peu',label:'Peu'},{value:'moyen',label:'Modérée'},{value:'beaucoup',label:'Importante'}]} />
    },

    ...buildMentalSteps(answers, update),

    // --- Autonomie (ADL) ---
    { id: 'adl', emoji: '🧍', title: 'Les gestes du quotidien', subtitle: "Cochez ce que vous faites tout(e) seul(e) actuellement",
      render: () => (
        <div className="space-y-2 mt-3" data-testid="q-adl">
          {adlItems.map((it) => {
            const active = !!gx(it.key);
            return (
              <button key={it.key} onClick={() => setEx(it.key, !active)}
                className={`w-full text-left p-3 rounded-2xl transition-all border-2 ${active ? 'bg-teal-500 border-teal-500 text-white' : 'bg-white border-slate-200 text-slate-700 hover:border-teal-300'}`}>
                <div className="flex items-center justify-between gap-2 text-sm">
                  <span>{it.label}</span>
                  {active && <span className="text-base">✓</span>}
                </div>
              </button>
            );
          })}
        </div>
      )
    },
    // --- Autonomie avancée (IADL) ---
    { id: 'iadl', emoji: '🏠', title: 'Les activités à l\'extérieur et à la maison', subtitle: "Cochez ce que vous faites tout(e) seul(e)",
      render: () => {
        const items = answers.sex === 'F' ? [...iadlCommon, ...iadlFemme] : iadlCommon;
        return (
          <div className="space-y-2 mt-3" data-testid="q-iadl">
            {items.map((it) => {
              const active = !!gx(it.key);
              return (
                <button key={it.key} onClick={() => setEx(it.key, !active)}
                  className={`w-full text-left p-3 rounded-2xl transition-all border-2 ${active ? 'bg-teal-500 border-teal-500 text-white' : 'bg-white border-slate-200 text-slate-700 hover:border-teal-300'}`}>
                  <div className="flex items-center justify-between gap-2 text-sm">
                    <span>{it.label}</span>
                    {active && <span className="text-base">✓</span>}
                  </div>
                </button>
              );
            })}
          </div>
        );
      }
    },

    // --- Chutes ---
    { id: 'chutes_12m', emoji: '⚖️', title: 'Chutes au cours des 12 derniers mois ?',
      render: () => <Slider testid="q-chutes" value={gx('chutes_12m')} onChange={(v) => setEx('chutes_12m', v)} min={0} max={20} step={1} unit=" chute(s)"
        presets={[{ value: 0, label: 'Aucune' }, { value: 1, label: '1' }, { value: 2, label: '2' }, { value: 3, label: '3' }, { value: 5, label: '4+' }]} />
    },
    { id: 'chutes_peur', emoji: '⚖️', title: 'Peur de tomber dans votre quotidien ?', subtitle: '0 = pas du tout · 10 = énormément',
      render: () => <Slider testid="q-peur" value={gx('chutes_peur')} onChange={(v) => setEx('chutes_peur', v)} min={0} max={10} step={1} unit="/10"
        presets={[
          { value: 0, label: '😌 Aucune' },
          { value: 5, label: '😐 Modérée' },
          { value: 9, label: '😟 Très peur' },
        ]} />
    },
    { id: 'aides_domicile', emoji: '🤝', title: 'Bénéficiez-vous d\'une aide à domicile ?',
      render: (a, u, advance) => <Choice testid="q-aides" value={gx('aides_domicile')} onChange={(v) => { setEx('aides_domicile', v); advance(); }}
        options={[{value:'yes',label:'Oui'},{value:'no',label:'Non'},{value:'nsp',label:'À évoquer'}]} />
    },

    // Vaccinations (incluant zona + pneumocoque)
    { id: 'vaccin_dtp', emoji: SECTION_EMOJI.vaccin, title: 'DTP à jour ?', render: () =>
      <Choice testid="q-vac-dtp" value={answers.vaccin_dtp} onChange={(v) => { update({ vaccin_dtp: v }); advance(); }} options={YES_NO_NSP} /> },
    { id: 'vaccin_grippe', emoji: SECTION_EMOJI.vaccin, title: 'Grippe cette année ?', render: () =>
      <Choice testid="q-vac-gr" value={answers.vaccin_grippe} onChange={(v) => { update({ vaccin_grippe: v }); advance(); }}
        options={[{value:'ok',label:'Oui'},{value:'nsp',label:'Pas sûr'},{value:'no',label:'Non'}]} /> },
    { id: 'vaccin_covid', emoji: SECTION_EMOJI.vaccin, title: 'COVID (< 1 an) ?', render: () =>
      <Choice testid="q-vac-cov" value={answers.vaccin_covid} onChange={(v) => { update({ vaccin_covid: v }); advance(); }}
        options={[{value:'ok',label:'Oui'},{value:'nsp',label:'Pas sûr'},{value:'no',label:'Non'}]} /> },
    { id: 'vaccin_zona', emoji: SECTION_EMOJI.vaccin, title: 'Vaccin zona ?', render: () =>
      <Choice testid="q-vac-zona" value={gx('vaccin_zona')} onChange={(v) => { setEx('vaccin_zona', v); advance(); }} options={YES_NO_NSP} /> },
    { id: 'vaccin_pneumo', emoji: SECTION_EMOJI.vaccin, title: 'Pneumocoque ?', subtitle: 'Recommandé en cas de comorbidités',
      render: (a, u, advance) => <Choice testid="q-vac-pneumo" value={gx('vaccin_pneumo')} onChange={(v) => { setEx('vaccin_pneumo', v); advance(); }} options={YES_NO_NSP} /> },

    // Dépistages tardifs
    ...(answers.sex === 'F' ? [
      { id: 'depistage_mammo', emoji: SECTION_EMOJI.depistage, title: 'Mammographie (jusqu\'à 74 ans) ?',
        render: (a, u, advance) => <Choice testid="q-dep-m" value={answers.depistage_mammo} onChange={(v) => { update({ depistage_mammo: v }); advance(); }} options={YES_NO_NSP} /> },
    ] : []),
    { id: 'depistage_hemoccult', emoji: SECTION_EMOJI.depistage, title: 'Dépistage cancer colorectal (jusqu\'à 74 ans) ?',
      render: (a, u, advance) => <Choice testid="q-dep-h" value={answers.depistage_hemoccult} onChange={(v) => { update({ depistage_hemoccult: v }); advance(); }}
        options={[{value:'ok',label:'Fait'},{value:'nsp',label:'Pas sûr'},{value:'no',label:'Non'}]} />
    },
    ...(answers.sex === 'H' && (answers.tabac === 'current' || answers.tabac === 'former') ? [
      { id: 'depistage_aaa', emoji: SECTION_EMOJI.depistage, title: 'Échographie abdominale (anévrisme aorte) ?',
        subtitle: 'Recommandée chez les fumeurs/anciens fumeurs 65-75 ans',
        render: (a, u, advance) => <Choice testid="q-dep-aaa" value={gx('depistage_aaa')} onChange={(v) => { setEx('depistage_aaa', v); advance(); }}
          options={[{value:'ok',label:'Fait'},{value:'nsp',label:'Pas sûr'},{value:'no',label:'Non'}]} /> },
    ] : []),
    ...buildRedFlagsStep(config, answers, update),
  ];
}
